module.exports = __webpack_public_path__ + "assets/img/f22719a9f60c80fb74b24ee1b96f8044.png";